/**
 * 클라이언트 상태(UI 전용) — Zustand.
 *
 * 서버 상태(draft 목록·상세 등)는 TanStack Query가 관리하므로 여기엔 두지 말 것.
 */
import { create } from 'zustand';
import type { UsageAlert } from '@content-platform/shared';

interface UiState {
  /** Phase 4: /api/batch 응답의 usageAlert. navigate 직후에도 노출되어야 하므로 전역에 둔다. */
  usageAlert: UsageAlert | null;
  setUsageAlert: (alert: UsageAlert | null) => void;
  dismissUsageAlert: () => void;
}

export const useUiStore = create<UiState>((set) => ({
  usageAlert: null,
  setUsageAlert: (usageAlert) => set({ usageAlert }),
  dismissUsageAlert: () => set({ usageAlert: null }),
}));
